// extracted by mini-css-extract-plugin
export default {"legalNotice":"_3F4gJ4oJ3INA0S22erqswf"};